import { ActionTypeV1 } from 'bones/utils/voicebox/modelingAndMapping/v1/types';

export const MODELING_AND_MAPPING_V1 = 1;

export const ACTION_MODEL_CONCEPT_CLASS_DATA_V1_SCHEMA = {
  type: 'object',
  properties: {
    iri: { type: 'string' },
    label: { type: 'string' },
    description: { type: 'string' },
  },
  additionalProperties: false,
  required: ['iri'],
};

export const ACTION_MODEL_CONCEPT_RELATIONSHIP_DATA_V1_SCHEMA = {
  type: 'object',
  properties: {
    iri: { type: 'string' },
    label: { type: 'string' },
    description: { type: 'string' },
    domains: { type: 'array', items: { type: 'string' } },
    ranges: { type: 'array', items: { type: 'string' } },
  },
  additionalProperties: false,
  required: ['iri'],
};

export const ACTION_MODEL_CONCEPT_ATTRIBUTE_DATA_V1_SCHEMA = {
  type: 'object',
  properties: {
    iri: { type: 'string' },
    label: { type: 'string' },
    description: { type: 'string' },
    domains: { type: 'array', items: { type: 'string' } },
    ranges: { type: 'array', items: { type: 'string' } },
  },
  additionalProperties: false,
  required: ['iri'],
};

export const ACTION_IRI_DATA_V1_SCHEMA = {
  type: 'object',
  properties: {
    iri: { type: 'string' },
  },
  additionalProperties: false,
  required: ['iri'],
};

export const ACTION_V1_SCHEMA = {
  type: 'object',
  required: ['type', 'data'],
  oneOf: [
    {
      properties: {
        type: { const: ActionTypeV1.CREATE_MODEL_CONCEPT_CLASS },
        data: ACTION_MODEL_CONCEPT_CLASS_DATA_V1_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        type: { const: ActionTypeV1.CREATE_MODEL_CONCEPT_RELATIONSHIP },
        data: ACTION_MODEL_CONCEPT_RELATIONSHIP_DATA_V1_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        type: { const: ActionTypeV1.CREATE_MODEL_CONCEPT_ATTRIBUTE },
        data: ACTION_MODEL_CONCEPT_ATTRIBUTE_DATA_V1_SCHEMA,
      },
      additionalProperties: false,
    },

    {
      properties: {
        type: { const: ActionTypeV1.UPDATE_MODEL_CONCEPT_CLASS },
        data: ACTION_MODEL_CONCEPT_CLASS_DATA_V1_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        type: { const: ActionTypeV1.UPDATE_MODEL_CONCEPT_RELATIONSHIP },
        data: ACTION_MODEL_CONCEPT_RELATIONSHIP_DATA_V1_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        type: { const: ActionTypeV1.UPDATE_MODEL_CONCEPT_ATTRIBUTE },
        data: ACTION_MODEL_CONCEPT_ATTRIBUTE_DATA_V1_SCHEMA,
      },
      additionalProperties: false,
    },

    {
      properties: {
        type: { const: ActionTypeV1.DELETE_MODEL_CONCEPT_CLASS },
        data: ACTION_IRI_DATA_V1_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        type: { const: ActionTypeV1.DELETE_MODEL_CONCEPT_ATTRIBUTE },
        data: ACTION_IRI_DATA_V1_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        type: { const: ActionTypeV1.DELETE_MODEL_CONCEPT_RELATIONSHIP },
        data: ACTION_IRI_DATA_V1_SCHEMA,
      },
      additionalProperties: false,
    },
  ],
};
